import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, Receipt } from "lucide-react";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/orders").then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, []);

  const badge = (s) =>
    s === "paid" ? "bg-primary/10 text-primary" : s === "pending" ? "bg-secondary text-muted-foreground" : "bg-accent/10 text-accent";

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-primary" /></div>;

  return (
    <div>
      <h1 className="font-heading font-black text-3xl tracking-tight">Orders</h1>
      <p className="text-muted-foreground mt-2">{orders.length} transactions.</p>

      {orders.length === 0 ? (
        <div className="bg-white border border-border p-10 text-center mt-8">
          <Receipt className="w-10 h-10 text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">No orders yet.</p>
        </div>
      ) : (
        <div className="bg-white border border-border mt-8 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border text-left text-muted-foreground">
                <th className="p-4 font-medium">Customer</th>
                <th className="p-4 font-medium">Product</th>
                <th className="p-4 font-medium">Amount</th>
                <th className="p-4 font-medium">Status</th>
                <th className="p-4 font-medium">Date</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.session_id} data-testid={`admin-order-${o.id}`} className="border-b border-border last:border-0">
                  <td className="p-4">{o.user_email}</td>
                  <td className="p-4">{o.product_name}</td>
                  <td className="p-4 font-medium">${o.amount?.toLocaleString()}</td>
                  <td className="p-4"><span className={`text-xs px-2 py-1 font-medium ${badge(o.payment_status)}`}>{o.payment_status}</span></td>
                  <td className="p-4 text-muted-foreground">{new Date(o.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
